const allowedExtensions = ['.aac', '.flac', '.mp3', '.m4a', '.oga', '.ogg', '.wav'];

export default function validateAudioFile(file) {
    const fileName = file.name.toLowerCase();
    return allowedExtensions.some(extension => fileName.endsWith(extension));
}
